import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-submit',
  templateUrl: './icon-submit.component.html',
  styleUrls: ['./icon-submit.component.scss']
})
export class IconSubmitComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
